import { useEffect, useRef, useState } from 'react'
import ReactCodeInput from 'react-code-input'
import { Link } from 'react-router-dom'
import { associateScreen, getScreen, preAssociateFlow } from '../../api/screen'
import { tv_url } from '../../config/config'
import { routes } from '../../config/routes'
import { getTabContentStyle } from '../../utils/tabs'
import { trans } from '../../utils/utilsTrans'
import { withMercure } from '../HOC/withMercure'
import { PrimaryButton, SecondaryButton } from '../UI/Buttons/Button'
import Modal from '../UI/Modal'
import Tabs from '../UI/Tabs'

const RenderQrCode = ({ data }) => {
  return (
    <div className='flex items-start space-x-16 p-24 mb-8'>
      <div className='p-8 bg-primaryLight3 text-primary rounded-full'>
        <i className='icon-devices text-2xl' />
      </div>
      <div className='flex-grow space-y-16'>
        <ul className='space-y-12'>
          <li className='flex items-start text-sm space-x-16'>
            <div className='font-semibold text-greyLight5'>1.</div>
            <p className='text-greyLight1'>
              {trans('flow.associate.step1')} <a href={tv_url}>{tv_url}</a>
            </p>
          </li>
          <li className='flex items-start text-sm space-x-16'>
            <div className='font-semibold text-greyLight5'>2.</div>
            <p className='text-greyLight1'>
              {trans('flow.associate.qrcode_step2')}
            </p>
          </li>
        </ul>
        <div className='w-full rounded-8 border border-greyLight7 bg-backgroundPrimary p-16'>
          <span
            className='block text-center text-primary text-2xl font-semibold'
            data-cy={'association-token'}
          >
            {data?.token}
          </span>
        </div>
      </div>
    </div>
  )
}

const RenderCode = ({ data, rootFlow, active }) => {
  const [figures, setFigures] = useState('')
  const inputRef = useRef(null)

  const onSubmit = (event) => {
    event.preventDefault()

    associateScreen(data.token, figures, rootFlow?.id)
      .then((res) => console.log(res))
      .catch((err) => console.error(err))
  }

  useEffect(() => {
    if (active) {
      setTimeout(() => inputRef.current.textInput.at(0).focus(), 100)
    }
  }, [active])

  return (
    <div className='flex items-start space-x-16 p-24 mb-8'>
      <div className='p-8 bg-primaryLight3 text-primary rounded-full'>
        <i className='icon-lock text-2xl' />
      </div>
      <div className='flex-grow space-y-16'>
        <ul className='space-y-12'>
          <li className='flex items-start text-sm space-x-16'>
            <div className='font-semibold text-greyLight5'>1.</div>
            <p className='text-greyLight1'>
              {trans('flow.associate.step1')} <a href={tv_url}>{tv_url}</a>
            </p>
          </li>
          <li className='flex items-start text-sm space-x-16'>
            <div className='font-semibold text-greyLight5'>2.</div>
            <p className='text-greyLight1'>
              {trans('flow.associate.code_step2')}
            </p>
          </li>
        </ul>
        <div className='w-full rounded-8 border border-greyLight7 bg-backgroundPrimary p-16'>
          <form className='flex flex-col items-center' onSubmit={onSubmit}>
            <span className='text-sm block mb-12 font-medium'>
              {trans('flow.associate.label_code')}
            </span>
            <div
              id='render-code'
              className='flex space-x-8 justify-center mb-16'
              data-cy={'code-config'}
            >
              <ReactCodeInput
                ref={inputRef}
                type='number'
                fields={10}
                placeholder={0}
                value={figures}
                onChange={(value) => setFigures(value)}
                inputStyle={{
                  margin: '4px',
                  MozAppearance: 'textfield',
                  width: '32px',
                  borderRadius: '8px',
                  fontSize: '1.25rem',
                  lineHeight: '1.75rem',
                  backgroundColor: 'white',
                  border: '1px solid rgb(225 229 232 / 1)',
                  paddingRight: '4px',
                  paddingLeft: '4px',
                  paddingTop: '2px',
                  paddingBottom: '2px',
                  textAlign: 'center',
                  WebkitAppearance: 'none',
                  appearance: 'none',
                }}
              />
            </div>
            <PrimaryButton
              text={trans('flow.associate.associate_screen')}
              cypress='associate-screen'
              size='small'
              type='submit'
            />
          </form>
        </div>
      </div>
    </div>
  )
}

const RenderUrl = ({ data }) => {
  const [copied, setCopied] = useState(false)
  const url = `${tv_url}${data?.token}`

  useEffect(() => {
    if (copied)
      setTimeout(() => {
        setCopied(false)
      }, 1000)
  }, [copied])

  return (
    <div className='flex items-start space-x-16 p-24 mb-8'>
      <div className='p-8 bg-primaryLight3 text-primary rounded-full'>
        <i className='icon-link text-2xl' />
      </div>
      <div className='flex-grow space-y-16'>
        <p className='text-greyLight1'>{trans('flow.associate.step1')}</p>
        <div className='flex w-full'>
          <input
            className='py-10 px-14 bg-backgroundPrimary rounded-l-8 border border-greyLight7 flex-grow text-greyLight3 text-sm leading-24'
            value={url}
            onChange={(event) => {
              event.target.value = url
            }}
          />
          <div className='relative overflow-hidden rounded-r-8 border border-greyLight7 border-l-0'>
            <button
              type='button'
              className='h-full text-sm text-primary font-medium px-16 hover:bg-primaryLight3 transition-colors duration-200'
              onClick={() =>
                navigator.clipboard.writeText(url).then(() => setCopied(true))
              }
            >
              {trans('copy')}
            </button>
            {copied ? (
              <div className='absolute top-0 left-0 w-full h-full flex items-center justify-center bg-white text-primary text-xl'>
                <i className='icon-check' />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  )
}

const RenderDirectUrl = ({ data, rootFlow }) => {
  const [isLoading, setIsLoading] = useState(false)

  const onClick = (event) => {
    event.preventDefault()

    setIsLoading(true)
    const id = Date.now().toString().slice(3)

    associateScreen(data.token, id, rootFlow?.id)
      .then(() => {
        window.open(
          `${tv_url}?session_key=${data?.token}&id=${id}&preinitialize=true`,
          '_blank'
        )
      })
      .catch((err) => console.error(err))
      .finally(() => setIsLoading(false))
  }

  return (
    <div className='flex items-start space-x-16 p-24 mb-8'>
      <div className='p-8 bg-primaryLight3 text-primary rounded-full'>
        <i className='icon-link text-2xl' />
      </div>
      <div className='flex-grow space-y-16'>
        <p className='text-greyLight1'>
          {trans('flow.associate.direct_launch_step1')}
        </p>
        <div className='flex justify-center items-start w-full'>
          <PrimaryButton
            text={trans('flow.ui.associate')}
            cypress={'screens-association-by-launch'}
            icon={'icon-link'}
            loading={isLoading}
            disabled={false}
            extraClass={'hidden lg:flex'}
            onClick={onClick}
          />
        </div>
      </div>
    </div>
  )
}

const tabs = [
  {
    label: 'QRCode',
    slug: 'qrcode',
    Component: RenderQrCode,
  },
  {
    label: trans('flow.associate.configuration_code'),
    slug: 'code',
    Component: RenderCode,
  },
  // {
  //   label: 'Adresse web (URL)',
  //   slug: 'url',
  //   Component: RenderUrl,
  // },
  {
    label: trans('flow.associate.direct_launch'),
    slug: 'direct-launch',
    Component: RenderDirectUrl,
  },
]

const ModalLinkingScreen = ({
  closeModal,
  data,
  mercureData,
  onConfirm,
  rootFlow,
}) => {
  const [currentTab, setCurrentTab] = useState('qrcode')
  const [nextTab, setNextTab] = useState(null)
  const [previousTab, setPreviousTab] = useState(null)
  const [screen, setScreen] = useState(null)
  const [linkedSuccess, setLinkedSuccess] = useState(false)

  function onChangeTab(tab) {
    if (tab !== currentTab) {
      setPreviousTab(currentTab)
      setNextTab(tab)
      setTimeout(() => {
        setCurrentTab(tab)
        setPreviousTab(null)
        setNextTab(null)
      }, 200)
    }
  }

  useEffect(() => {
    getScreen({ id: data.id }).then((res) => {
      setScreen(res)
    })

    if (data.id && rootFlow.id) {
      preAssociateFlow(data.id, rootFlow.id).then().catch()
    }
  }, [])

  useEffect(() => {
    if (!mercureData || !mercureData.type || linkedSuccess) {
      return
    }

    switch (mercureData.type) {
      case 'accepted_screen':
        setLinkedSuccess(true)
        break
    }
  }, [mercureData])

  const currentIndex = tabs.findIndex((v) => v.slug === currentTab)
  const nextIndex = tabs.findIndex((v) => v.slug === nextTab)
  const previousIndex = tabs.findIndex((v) => v.slug === previousTab)

  if (linkedSuccess)
    return (
      <Modal type={'small'} hasCloseButton={false} closeModal={closeModal}>
        <div className='flex flex-col justify-center items-center p-24 mt-24'>
          <div className='p-12 bg-primary text-white rounded-full mb-16'>
            <i className='icon-check text-2xl' />
          </div>
          <h2 className='mb-8 font-semibold text-center'>
            {trans('flow.associate.success_title')}
          </h2>
          <span className='text-center text-greyLight2 text-sm'>
            {trans('flow.associate.success_text')}
            <Link className='text-primary font-medium' to={routes.help}>
              {trans('nav.help')}
            </Link>
          </span>
          <div className='flex space-x-16 mt-24 w-full'>
            <SecondaryButton
              to={routes.help}
              cypress='link-help'
              text={trans('check_help')}
            />
            <PrimaryButton
              text={trans('flow.associate.confirm_button')}
              extraClass='flex-grow'
              onClick={closeModal}
              cypress={'works-well'}
            />
          </div>
        </div>
      </Modal>
    )

  return (
    <Modal
      type={'semiMedium'}
      closeModal={closeModal}
      title={trans('flow.associate.share')}
      subTitle={trans('flow.associate.subtitle_share_method')}
    >
      <div className='px-24 mt-20'>
        <Tabs
          tabs={tabs}
          currentTab={nextTab || currentTab}
          changeTab={onChangeTab}
          customClass='border-b-[1px] border-greyLight7'
        />
      </div>
      <div className='relative flex-grow min-h-[0] flex flex-col overflow-hidden'>
        <div className='flex w-[300%] flex-grow min-h-[0] overflow-hidden'>
          {tabs.map((tab, i) => {
            const Comp = tab.Component

            return (
              <div
                key={`key_${tab.slug}`}
                className={
                  'flex flex-col h-auto w-1/3 ' +
                  (currentTab === tab.slug
                    ? 'z-10 order-1 overflow-hidden'
                    : 'overflow-x-hidden invisible order-2')
                }
              >
                <div
                  className={
                    'transition-all space-y-40 duration-200 h-full flex-grow min-h-[0px] overflow-hidden ' +
                    getTabContentStyle(
                      currentIndex,
                      nextIndex,
                      previousIndex,
                      i
                    )
                  }
                >
                  <Comp
                    active={currentTab === tab.slug}
                    data={screen}
                    onConfirm={onConfirm}
                    rootFlow={rootFlow}
                  />
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </Modal>
  )
}

export default withMercure(ModalLinkingScreen)
